// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feed-comments {
    background: none;
    border-radius: 10px;
    height: 150px;
    margin-top: 5px;
    display: flex;
    flex-direction: column;
}

.comments-container {
    margin-top: 0px;
    border-radius: 10px;
    font-family: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif";
    font-size: 20px;
    color: white;
    min-height: 50px;
    height: auto;
    max-height: 100px;
    overflow-y: scroll;
  }
`, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Styles/UACommonStyles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,qJAAqJ;IACrJ,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB","sourcesContent":[".feed-comments {\n    background: none;\n    border-radius: 10px;\n    height: 150px;\n    margin-top: 5px;\n    display: flex;\n    flex-direction: column;\n}\n\n.comments-container {\n    margin-top: 0px;\n    border-radius: 10px;\n    font-family: \"system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif\";\n    font-size: 20px;\n    color: white;\n    min-height: 50px;\n    height: auto;\n    max-height: 100px;\n    overflow-y: scroll;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
